import { render } from "./UiUxStrategy.vue?vue&type=template&id=dd770624"
import script from "./UiUxStrategy.vue?vue&type=script&lang=js"
export * from "./UiUxStrategy.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\USER\\Desktop\\New folder\\Lynkme360\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__